/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { theme } from "@nordcloud/gnui";

export const ACTION_COLORS: Record<string, string> = {
  "Scan & Patch": theme.color.support.blue,
  "Scan & Install Windows Updates": theme.color.support.cyan,
  Reboot: theme.color.support.orange,
  Delay: theme.color.support.grey,
  "Start Virtual Machine": theme.color.support.green,
  "Stop Virtual Machine": theme.color.support.red,
  "Update SSM Agent": theme.color.support.purple,
};

export const DEFAULT_ACTION_COLOR = theme.color.interactive.primary;

export const PAST_EVENT_OPACITY = 0.4;

export const VIEW_OPTIONS = [
  { label: "Day", value: "timeGridDay" as const },
  { label: "Week", value: "timeGridWeek" as const },
  { label: "Month", value: "dayGridMonth" as const },
];

export const DEFAULT_VIEW = "timeGridWeek" as const;

export const TIMELINE_PAGE_LIMIT = 200;
